export const DAY = 'day'
export const YESTERDAY = 'yesterday'
export const WEEK = 'week'
export const MONTH = 'month'